import PropTypes from 'prop-types';
import { ClientStatus } from './constants';

export const ActiveClientProptype = PropTypes.shape({
  externalClientConnectionId: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
  status: ClientStatus.ACTIVE,
});

export const InactiveClientProptype = PropTypes.shape({
  externalClientConnectionId: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
  status: ClientStatus.INACTIVE,
});

export const PendingClientProptype = PropTypes.shape({
  externalInviteId: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  clientEmail: PropTypes.string.isRequired,
  inviteToken: PropTypes.string.isRequired,
  status: ClientStatus.PENDING,
});
